import jwtDecode from "jwt-decode";
import axios from "axios";
import config from "../config.json";

const apiUrl = config.apiUrl;

const apiEndpoint = apiUrl + "/auth";
const tokenKey = "token";

setJwt(getJwt());

export async function login(email, password) {
  const { data } = await axios.post(apiEndpoint, { email, password });
  if (data.status === "error") throw new Error();
  localStorage.setItem(tokenKey, data.token);
}

export async function isValidUser(email, password) {
  const { data } = await axios.post(apiEndpoint, { email, password });
  if (data.status === "error") return Promise.reject('error');
  if (data.token) return 'success';
}

export function loginWithJwt(jwt) {
  localStorage.setItem(tokenKey, jwt);
}

export function logout() {
  localStorage.removeItem(tokenKey);
}

export function getCurrentUser() {
  try {
    const jwt = localStorage.getItem(tokenKey);
    return jwtDecode(jwt);
  } catch (ex) {
    return null;
  }
}

export function getJwt() {
  return localStorage.getItem(tokenKey);
}

function setJwt(jwt) {
  axios.defaults.headers.common["x-auth-token"] = jwt;
}

export default {
  login,
  loginWithJwt,
  logout,
  getCurrentUser,
  getJwt,
};
